import cx from "clsx";
import React from "react";

import { useFieldNumEditions } from "./hooks";
import styles from "./index.module.scss";

import InputInteger from "@/modules/kreate-modals/components/InputInteger";

type Props = {
  className?: string;
  label?: string;
  tooltip?: string;
  style?: React.CSSProperties;
  api: ReturnType<typeof useFieldNumEditions>;
  disabled?: boolean;
  showMaxButton?: boolean;
};

export default function FieldNumEditions({
  className,
  label,
  tooltip,
  style,
  api,
  disabled,
  showMaxButton,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <InputInteger
        label={label || "Number of Editions"}
        value={api.draft}
        onChange={api.setDraft}
        onBlur={api.validateAfterEditing}
        placeholder="Number"
        error={api.error}
        tooltip={tooltip || "Number of Editions"}
        disabled={disabled}
        unit="Editions"
        actions={{
          increase: api.increase,
          decrease: api.decrease,
          setToMax: showMaxButton ? api.setToMax : null,
        }}
      />
    </div>
  );
}
